import {
  SET_ASSESSEE_ROLE_REDUCER_STATE,
  SET_ASSOCIATE_ROLE_REDUCER_STATE,
  CLEAR_ROLE_REDUCER_STATE,
  SET_ROLE_DYNAMIC_STATE,
  SET_SETUP_PERMISSION,
  SET_SETUP_PERMISSION_NEW,
  SET_ROLE_REDUCER_STATE,
  SET_ASSESSEE_ROLE_CLASSIFICAION_STATE,
  SET_ASSOCIATE_ROLE_CLASSIFICAION_STATE
} from '../actionType';

const initialState = {
  assesseeRole: {
    informationBasic: {
      assesseeRoleName: '',
      assesseeRoleNameVerification: false,
      assesseeRoleDescription: '',
      assesseeRolePicture: '',
      assesseeRolePictureVerification: false
    },
    informationSetup: {
      assesseeRolePermission: {
        assesseeAssesseeSelfPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          assesseePermissionInformation: 'key'
        },
        assesseeAssociateSelfPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          assesseePermissionInformation: 'key'
        },
        assesseeAssesseeDistinctPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          assesseePermissionInformation: 'all'
        },
        assesseeAssesseeDistinctPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          assesseePermissionInformation: 'all'
        },
        assesseeAssesseeGroupPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          assesseePermissionInformation: 'key'
        },
        assesseeAssesseeRolePermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          assesseePermissionInformation: 'key'
        },
        assesseeAssesseeTypePermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          assesseePermissionInformation: 'key'
        },
        assesseeAssessmentDistinctPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          assesseePermissionInformation: 'key'
        },
        assesseeAssessmentGroupPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          assesseePermissionInformation: 'key'
        },
        assesseeAssessmentTypePermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          assesseePermissionInformation: 'key'
        },
        assesseeAssignmentDistinctPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          assesseePermissionInformation: 'key'
        },
        assesseeAssignmentGroupPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          assesseePermissionInformation: 'key'
        },
        assesseeAssignmentReportPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          assesseePermissionInformation: 'key'
        },
        assesseeAssignmentTypePermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          assesseePermissionInformation: 'key'
        },
        assesseeAssociateDistinctPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          assesseePermissionInformation: 'key'
        },
        assesseeAssociateGroupPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          assesseePermissionInformation: 'key'
        },
        assesseeAssociateNodePermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          assesseePermissionInformation: 'key'
        },
        assesseeAssociateRolePermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          assesseePermissionInformation: 'key'
        },
        assesseeAssociateTypePermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          assesseePermissionInformation: 'key'
        },
        assesseeiGuruAnalyticDistinctPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          assesseePermissionInformation: 'key'
        },
        assesseeiGuruAnalyticGroupPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          assesseePermissionInformation: 'key'
        },
        assesseeiGuruAnalyticTypePermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          assesseePermissionInformation: 'key'
        },
        assesseeItemDistinctPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          assesseePermissionInformation: 'key'
        },
        assesseeItemGroupPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          assesseePermissionInformation: 'key'
        },
        assesseeItemTypePermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          assesseePermissionInformation: 'key'
        }
      },
      assesseeRoleClassification: {
        assesseeRoleClassificationPrimary: ''
      },
      assesseeRoleDefault:false,
      assesseeRoleAdmin:false,
      assesseeRoleManager:false,
      assesseeRoleAssistant:false,
    }
  },
  associateRole: {
    informationBasic: {
      associateRoleName: '',
      associateRoleNameVerification: false,
      associateRoleDescription: '',
      associateRolePicture: '',
      associateRolePictureVerification: false
    },
    informationEngagement: {
      associateRoleStatus: '',
      associateRoleTag: {
        associateRoleTagPrimary: '',
        associateRoleTagSecondary: null
      },
      associateRoleTenure: {
        associateRoleTenureDateTimeEnd: null,
        associateRoleTenureDateTimeStart: ''
      }
    },
    informationSetup: {
      associateRolePermission: {
        associateAssesseeSelfPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssociateSelfPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssesseeDistinctPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssesseeGroupBespokePermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssesseeGroupGenericPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssesseeRoleBespokePermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssesseeRoleGenericPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssesseeTypeBespokePermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssesseeTypeGenericPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssessmentDistinctPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssessmentGroupBespokePermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssessmentGroupGenericPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssessmentTypeBespokePermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssessmentTypeGenericPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssignmentDistinctPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssignmentGroupBespokePermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssignmentGroupGenericPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssignmentTypeBespokePermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssignmentTypeGenericPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssociateDistinctPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssociateSetupBespokePermission:{
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssociateSetupGenericPermission:{
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssociateGroupGenericPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssociateGroupBespokePermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssociateNodeBespokePermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssociateNodeGenericPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssociateRoleBespokePermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssociateRoleGenericPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssociateTypeBespokePermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateAssociateTypeGenericPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateiGuruAnalyticDistinctPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateiGuruAnalyticGroupBespokePermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateiGuruAnalyticGroupGenericPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateiGuruAnalyticTypeBespokePermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateiGuruAnalyticTypeGenericPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateItemDistinctPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateItemGroupBespokePermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateItemGroupGenericPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateItemTypeBespokePermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        },
        associateItemTypeGenericPermission: {
          create: false,
          delete: false,
          review: false,
          revise: false,
          share: false,
          sell: false,
          move: false
        }
      },
      associateRoleClassification: {
        associateRoleClassificationPrimary: ''
      }
    }
  }
};

const RoleCreateReducer = (istate = JSON.parse(JSON.stringify(initialState)), action) => {
  switch (action.type) {
    case SET_ASSESSEE_ROLE_REDUCER_STATE:
      return {
        ...istate,
        assesseeRole: {
          ...istate.assesseeRole,
          informationBasic: action.payload
        }
      };
    case SET_ASSOCIATE_ROLE_REDUCER_STATE:
      return {
        ...istate,
        associateRole: {
          ...istate.associateRole,
          informationBasic: action.payload
        }
      };
    case SET_ROLE_REDUCER_STATE:
      return {
        ...istate,
        [action.payload.objectName]: {
          ...istate[action.payload.objectName],
          [action.payload.stateName]: action.payload.value
        }
      };
    case SET_SETUP_PERMISSION:
      return {
        ...istate,
        [action.payload.objectName]: {
          ...istate[action.payload.objectName],
          informationSetup: {
            ...istate[action.payload.objectName].informationSetup,
            [action.payload.stateName]: {
              ...istate[action.payload.objectName].informationSetup[action.payload.stateName],
              [action.payload.actualStateName]: action.payload.value
            }
          }
        }
      };
    case SET_SETUP_PERMISSION_NEW:
      return {
        ...istate,
        [action.payload.objectName]: {
          ...istate[action.payload.objectName],
          informationSetup: {
            ...istate[action.payload.objectName].informationSetup,
            [action.payload.stateName]: action.payload.value
          }
        }
      };
    case SET_ROLE_DYNAMIC_STATE:
      return {
        ...istate,
        [action.payload.objectName]: {
          ...istate[action.payload.objectName],
          [action.payload.stateName]: {
            ...istate[action.payload.objectName][action.payload.stateName],
            [action.payload.actualStateName]: action.payload.value
          }
        }
      };
    case SET_ASSESSEE_ROLE_CLASSIFICAION_STATE:
      return {
        ...istate,
        assesseeRole: {
          ...istate.assesseeRole,
          informationSetup: {
            ...istate.assesseeRole.informationSetup,
            assesseeRoleClassification: action.payload
          }
        }
      };
    case SET_ASSOCIATE_ROLE_CLASSIFICAION_STATE:
      return {
        ...istate,
        associateRole: {
          ...istate.associateRole,
          informationSetup: {
            ...istate.associateRole.informationSetup,
            associateRoleClassification: action.payload
          }
        }
      };
    case CLEAR_ROLE_REDUCER_STATE:
      return JSON.parse(JSON.stringify(initialState));
    default:
      return istate;
  }
};

export default RoleCreateReducer;
